import styled from 'styled-components';
import { ICreatorContentDB } from 'type/db';

import ChannelContentCard from 'components/channel/ChannelContentCard';
import useCallbackRef from 'hooks/useCallbackRef';
import useCarousel from 'hooks/useCarousel';
import useDragPreventClick from 'hooks/useDragPreventClick';
import style from 'styles/styled-components/style';

type Props = {
	creatorPk: number;
	values: ICreatorContentDB[];
};
const SearchContentBoard = ({ creatorPk, values }: Props) => {
	const [carousel_wrapper_dom, carousel_wrapper_ref] = useCallbackRef([values]);
	const [carousel_body_dom, carousel_body_ref] = useCallbackRef([values]);
	const [control, drag_constraints, drag_condition] = useCarousel(
		carousel_wrapper_dom,
		carousel_body_dom,
		[values],
	);

	useDragPreventClick(carousel_body_dom, 'div', [values]);

	return (
		<ContentBoard flex="start" ref={carousel_wrapper_ref}>
			<ContentsCarouselBody
				flex="start"
				_gap="8px"
				ref={carousel_body_ref}
				drag={(values?.length ?? 0) < 4 ? false : 'x'}
				dragConstraints={drag_constraints}
				animate={control}
			>
				{values?.map((item, idx) => (
					<ChannelContentCard
						key={'ContentCard' + idx}
						content={item}
						creatorPk={creatorPk}
					/>
				))}
				{values?.length === 0 && (
					<Grid flex="center">
						<Text typo="span" color="gray">
							{'데이터가 없습니다.'}
						</Text>
					</Grid>
				)}
			</ContentsCarouselBody>
		</ContentBoard>
	);
};

const { Grid, Text } = style;

const ContentBoard = styled(Grid)`
	display: flex;
	padding-inline: 32px;
	padding-block: 16px;
	gap: 8px;

	overflow: hidden;

	border-radius: 8px;
	margin-top: 8px;
	background-color: ${({ theme }) => theme.colors.gray.gray_white};
`;

const ContentsCarouselBody = styled(Grid)`
	flex-wrap: nowrap;
`;

export default SearchContentBoard;
